"use strict";

require("core-js/modules/es.array.reduce.js");

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

var _core = require("@orbital-frame/core");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var _default = function _default(_ref) {
  var messengerService = _ref.messengerService;
  return Object.values(_core.phase).map(function (phaseKey) {
    return _defineProperty({}, phaseKey, {
      error: function error(e, _ref2) {
        var context = _ref2.context;
        var message = "Error: ".concat(e.message);

        if (context) {
          messengerService.respond(context, "`".concat(message, "`"));
        } else {
          throw e; // error happened outside of main runloop
        }
      }
    });
  }).reduce(function (acc, curr) {
    return _objectSpread({}, acc, {}, curr);
  }, {});
};

exports.default = _default;